import { Box, BoxProps, makeStyles } from '@material-ui/core';
import React from 'react';

export type MainProps = BoxProps & {

}

export function Main (props: MainProps) {
    const cls = useStyles();

    return (
        <Box className={cls.root} {...props} />
    )
}

const useStyles = makeStyles(theme => ({
    root: {
        marginTop: theme.spacing(8)
    }
}));